require("custom-event-polyfill");

module.exports = class Carousel {

    constructor(container) {

        this.container = container;
        this.slides = this.container.querySelectorAll("[data-slide]");

        this.container.querySelectorAll("[data-next]").forEach((button) => {

            button.addEventListener("click", this.Next.bind(this));

        });

        this.container.querySelectorAll("[data-previous]").forEach((button) => {

            button.addEventListener("click", this.Previous.bind(this));

        });

        this.container.querySelectorAll("[data-go-to]").forEach((button) => {

            button.addEventListener("click", this.GoTo.bind(this, parseInt(button.dataset.goTo)));

        });

        this.container.addEventListener("change", () => {

            this.container.querySelectorAll("[data-go-to]").forEach((button) => {

                delete button.dataset.current;

            });

            let button = this.container.querySelector(`[data-go-to="${this.container.dataset.currentIndex}"]`);

            if (button) {

                button.dataset.current = 1;

            }

        })

        document.addEventListener("keydown", (event) => {

            switch (event.keyCode) {

                case 37: this.Previous(); break;
                case 39: this.Next(); break;

            }

        });

        this.container.addEventListener("mouseover", this.Stop.bind(this));
        this.container.addEventListener("mouseout", this.Play.bind(this));

        this.Play();

    }

    /**
    * @param {integer} position zero-based position to move the carousel
    */
    GoTo(position) {

        if (position >= this.slides.length) {

            position = 0;

        } else if (position < 0) {

            position = this.slides.length - 1;

        }

        this.index = position;

        this.slides.forEach((slide) => {

            delete slide.dataset.current;

        });

        this.slides[this.index].dataset.current = 1;

        this.container.dataset.current = this.index + 1;
        this.container.dataset.currentIndex = this.index;

        this.container.dispatchEvent(new CustomEvent("change"));

    }

    Next() {

        this.GoTo(this.index + 1);

    }

    Previous() {

        this.GoTo(this.index - 1);

    }

    Play() {

        this.Stop();

        if (this.index === undefined) {

            this.GoTo(0);

        }

        this.interval = setInterval(this.Next.bind(this), 5000);

    }

    Stop() {

        clearInterval(this.interval);

    }
}